<template>
  <div class="Label-staff">
    <div style="margin-bottom:10px">
      <el-button type="primary" size="mini" @click="createHandle">新建欢迎语</el-button>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 233px)"
          ref="cusChatTable"
          style="font-size: 13px"
          @row-dblclick="handleRowDBClick"
        >
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <el-table-column
            type="index"
            min-width="50">
          </el-table-column>
          <el-table-column
            prop="welcomeContent"
            label="欢迎语"
            min-width="120"
          >
            <template slot-scope="scope">
              <div class="name-wrap">
                {{scope.row.welcomeContent}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="creatorName"
            label="创建人"
            min-width="120"
          ></el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button
                v-if="true"
                type="text"
                size="small"
                @click.native="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="true"
                type="text"
                size="small"
                @click.native="delHandle(scope.row)"
                >删除</el-button
              >
              <span v-if="!true" style="font-size: 12px">生成中</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <WelcomeDia
      :dialogVisible = "dialogVisible"
      :diaTitle="this.diaTitle"
      :editData="this.editData"
      @cancelHandle="cancelHandle"
      @saveHandle="saveHandle"
    ></WelcomeDia>
  </div>
</template>
<script>
import { getWelcome,delWelcome } from "@/api/activeCode/activeCode.js"
import WelcomeDia from "./welcome/WelcomeDia.vue"
export default {
  name: "CusChatSupervise",
  components: {
    WelcomeDia
  },
  data() {
    return {
      tableData: [],//欢迎语数据集合
      // loading: false,
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      dialogVisible:false, //欢迎语弹窗
      editData:null,//编辑的数据
      diaTitle:'',
    };
  },
  created() {
    this.getWelcome()
  },
  methods: {
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getWelcome()
    },
    //获取欢迎语列表
    getWelcome(){
      // this.loading = true;
      getWelcome(this.formInline,localStorage.getItem("Authorization")).then((res)=>{
        if (res.error.code == 200) {
          // this.loading = false;
          this.pageparm.total = res.data.total
          this.tableData = res.data.records
        }
      }).catch(err=>{})
    },
    //双击表格触发编辑
    handleRowDBClick(row){
      this.editData = row
      this.diaTitle = '编辑欢迎语';
      this.dialogVisible = true
    },
    // 打开新增弹窗
    createHandle(){
      this.diaTitle = '新建欢迎语';
      this.editData = null
      this.dialogVisible = true
    },
    //取消回调
    cancelHandle(){
      this.dialogVisible = false
    },
    //保存成功回调
    saveHandle(){
      this.dialogVisible = false
      this.getWelcome()
    },
    // 编辑
    handleEdit(row){
      this.editData = row
      this.diaTitle = '编辑欢迎语';
      this.dialogVisible = true
    },
    // 删除
    delHandle(row){
      this.$confirm('', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        message:`<div style="font-size:15px;">确定删除该内容？</div>`,
        // message:`<div style="font-size:15px;">确定删除该内容？</div><div style="font-size:12px;color:#999999">（删除后已添加到活码的欢迎语也将同步删除）</div>`,
        dangerouslyUseHTMLString:true,
        iconClass:"el-icon-warning",
        customClass:"delete-messege",
        center: true
      }).then(() => {
        delWelcome(
          {
            corpId:row.corpId,
            welcomeId:row.welcomeId
          }
          ,localStorage.getItem("Authorization")).then((res)=>{
          if (res.error.code == 200) {
            this.getWelcome()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        }).catch(err=>{})
      }).catch(() => {});

    },
  }
};
</script>
<style lang="scss" scoped> 
    .Label-staff{
      .el-table {
        .cell{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .name-wrap{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
        .dialog-label{
            .el-dialog {
                max-height: 800px;
                overflow-y: scroll;
            }
            .el-dialog__body{
                padding-bottom: 10px;
            }
            .el-dialog__footer{
               text-align: center;
            }
        }
        .el-tag--plain{
            border-color: #606266;
            color: #606266;
        }
        .el-textarea__inner{
            min-height: 150px !important;
        }
    }

</style>